// ===========================================
// BUSTED! BLACKJACK - TOS ACCEPTANCE MODAL
// ===========================================

import { useState } from 'react';
import { useAuthStore } from '../stores';
import { Modal } from './Modal';

interface TosAcceptanceModalProps {
  onAccepted: () => void;
}

export function TosAcceptanceModal({ onAccepted }: TosAcceptanceModalProps) {
  const { acceptTos } = useAuthStore();
  const [isChecked, setIsChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAccept = async () => {
    if (!isChecked) return;

    setIsSubmitting(true);
    setError(null);

    const success = await acceptTos();

    if (success) {
      onAccepted();
    } else {
      setError('Failed to accept Terms of Service. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      variant="default"
      blocking={true}
      title="Terms of Service"
      subtitle="Please review and accept to continue"
      showClose={false}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      maxWidthClass="max-w-lg"
    >
      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto p-6 max-h-[50vh]">
        <div className="space-y-4 text-sm text-gray-300">
          <div className="bg-casino-gold-500/10 border border-casino-gold-500/30 rounded-lg p-4">
            <p className="text-casino-gold-400 font-semibold">IMPORTANT NOTICE</p>
            <p className="mt-2">
              BUSTED! Blackjack is a <strong>FREE-TO-PLAY</strong> social casino game for
              <strong> ENTERTAINMENT PURPOSES ONLY</strong>.
            </p>
          </div>

          <div className="space-y-3">
            <h3 className="font-semibold text-white">Key Points:</h3>

            <div className="flex gap-2">
              <span className="text-casino-green-400">$</span>
              <p><strong>No Real Money:</strong> All currency is virtual "play money" with no cash value.</p>
            </div>

            <div className="flex gap-2">
              <span className="text-casino-green-400">$</span>
              <p><strong>No Cash Outs:</strong> Virtual chips cannot be redeemed, refunded, or exchanged for real money.</p>
            </div>

            <div className="flex gap-2">
              <span className="text-casino-green-400">$</span>
              <p><strong>Age Requirement:</strong> You must be 18 years or older to use this service.</p>
            </div>

            <div className="flex gap-2">
              <span className="text-casino-green-400">$</span>
              <p><strong>Entertainment Only:</strong> Success in this game does not predict success in real gambling.</p>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-4">
            <p className="text-gray-400">
              By accepting, you agree to our full{' '}
              <a
                href="/terms.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-casino-gold-400 hover:underline"
              >
                Terms of Service
              </a>
              {' '}and confirm you are 18+ years old.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="p-6 border-t border-gray-700 space-y-4">
        {error && (
          <div className="bg-red-500/10 border border-red-500/50 rounded-lg p-3 text-red-400 text-sm text-center">
            {error}
          </div>
        )}

        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            className="mt-1 w-5 h-5 rounded border-gray-600 bg-gray-700 text-casino-gold-500 focus:ring-casino-gold-500 focus:ring-offset-gray-800"
          />
          <span className="text-sm text-gray-300">
            I confirm that I am 18 years or older and I agree to the Terms of Service.
            I understand this is a free social game with no real money gambling.
          </span>
        </label>

        <button
          onClick={handleAccept}
          disabled={!isChecked || isSubmitting}
          className={`w-full py-3 rounded-lg font-semibold transition-colors ${
            isChecked && !isSubmitting
              ? 'bg-casino-gold-500 text-gray-900 hover:bg-casino-gold-400'
              : 'bg-gray-700 text-gray-500 cursor-not-allowed'
          }`}
        >
          {isSubmitting ? 'Accepting...' : 'Accept & Continue'}
        </button>
      </div>
    </Modal>
  );
}

export default TosAcceptanceModal;
